export const translations = {
  'en': {
    'You can look for a group and filter your search results, it works the same as the Users page.': '',
    'Now let’s take a look at user accounts! We’ve entered your name in the search bar to show you how it works.': '',
    'For faster results, you can use filters to locate a user account.': '',
    'You can view and edit the user\'s account here.': '',
    'Next': '',
    'Previous': '',
    'Skip': '',
    'Done': '',
    'Continue': '',
    'Thanks for taking the tour! If you need a refresher, you can always access it from the menu.': '',
    'Let\'s start with the basics - you can change the dashboard\'s language by clicking on your profile.': '',
    'With this navigation menu, you can access the dashboard features available to you.': '',
    'Want to see how much traffic you got over the last few weeks? Use the date filter to select the last 30 days.': '',
    'Wonderful! You can hover over the graph to see more information. If you see "No Data" don\'t worry - check back soon to view the user activity on the Platform.': '',
    'Seeing the most popular pages is easy! You can view which topics, articles, tools, and services your members are engaging with most.': '',
    'Novus Health Dashboard': '',
    'All Groups': '',
    'SMS': '',
    'Email': '',
    'Push Notification': '',
    'Send As': '',
    'Today': '',
    'Yesterday': '',
    'Last 7 Days': '',
    'Last 30 Days': '',
    'Select': '',
    'Privacy': '',
    'Legal': '',
    'Copyright': '',
    'Health Care Services International Inc.': '',
    'o/a Novus Health': '',
    'You have encountered an error and the requested page cannot be displayed. Please try again.': '',
    'Loading...': '',
    'Hi,': '',
    'Logout': '',
    'No Data': '',
    'Got it': '',
    'Are you sure you want to leave this page?': '',
    'Search': '',
    'No options': '',
    'Take a Tour': '',
    'Access Denied': '',
    'You do not have permission to access this page. For more information, please contact your Site Administrator.': '',
    'Go back': '',
    'Groups': '',
    'Create': '',
    'Unsaved changes will be lost.': '',
    'Confirm': '',
    'Cancel': '',
    'Are you sure you want to switch languages?': '',
    'Deactivate this group': '',
    'Deactivate': '',
    'Are you sure you want to deactivate this group?': '',
    'This will also deactivate any sub-groups related to this group.': '',
    'Products and Services will be unavailable': '',
    'Are you sure you want to change the Parent Group to {parentGroup_Name}?': '',
    'The following Products and Services will be unavailable:': '',
    'Back to View': '',
    'Edit': '',
    'Save': '',
    'Unsaved changes will be lost': '',
    'Are you sure you want to proceed?': '',
    'Permission(s) will be removed': '',
    '{n} Permission(s) will be removed': '',
    'Are you sure you want to change the user\'s group to {newGroupName}? The following permission(s) will be removed from the user\'s account:': '',
    '{n} Are you sure you want to change the user\'s group to {newGroupName}? The following permission(s) will be removed from the user\'s account:': '',
    'Users': '',
    'Member Activity - Data Reports': '',
    'Access monthly reports to better understand how your members are taking advantage of the Novus Health health information specialist service. Reports will appear on this page within the first two weeks of the following month. Only specified administrators have access to this data.': '',
    'Oops! Something went wrong, please try again and contact us if the issue continues.': '',
    'Add a User': '',
    'Compose Message': '',
    'Back': '',
    'Add a subject (Email Only)': '',
    'Send': '',
    'New': '',
    'Sent': '',
    'Received': '',
    'User': '',
    'Activity': '',
    'Messages': '',
    'New Message': '',
    'How\'re we doing?': '',
    'The Novus Dashboard is in beta, and we would love to get your feedback on how we’re doing. Looks, functionality, ease of use, whatever! Anything goes.': '',
    'Name': '',
    'Topic': '',
    'Feedback': '',
    'Feedback...': '',
    'Submit': '',
    'Bug Report': '',
    'Design': '',
    'Content': '',
    'Other': '',
    'Help': '',
    'Reset Your Password': '',
    'We need some information before we begin.': '',
    'All Done!': '',
    'Log In': '',
    'Welcome to your dashboard': '',
    'This is just the start.': '',
    'Your dashboard begins with what matters to you the most. The Platform Usage page enables you to gain the data you need to help you build your business intelligence:': '',
    'Understand usage trends over time': '',
    'Know how your members are engaging with the platform': '',
    'Gain insight into what topics your members are exploring': '',
    'Focus your search with these useful features:': '',
    'Set your date range': '',
    'View group level data': '',
    'Review sessions or page views': '',
    'Analyze browser and OS usage percentages': '',
    'View the most popular pages in each language': '',
    'Check back often as we release new updates, features, and controls that help you manage the experience of your clients and members!': '',
    'Password Reset': '',
    'Log Into Your Novus Health Dashboard': '',
    'Login': '',
    'Forgot Password': '',
    'Welcome to the Novus Health Dashboard!': '',
    'Looks like this is not the page you were looking for. To access your organization’s custom site, please enter the URL provided into the address bar at the top of the browser.': '',
    'Still can’t find what you’re looking for? Please contact your admin for information on how to access your custom dashboard.': '',
    'Welcome aboard!': '',
    'Start tour': '',
    'Maybe later': '',
    'Discover trends.': '',
    'Gain insights.': '',
    'Make decisions.': '',
    'Would you like to take the tour?': '',
    'Export': '',
    'Platform Usage': '',
    'Select Language': '',
    'Show': '',
    'Select Limit': '',
    'per page': '',
    'Page Title': '',
    'Page Views': '',
    'Unique Visitors': '',
    'Total': '',
    'var%': '%',
    'Operating System': '',
    'Unique Visitors Percentage': '',
    'Browser': '',
    'Browsers': '',
    'Filter by date': '',
    'Filter by group': '',
    'Starts': '',
    'Ends': '',
    'Health Risk Assessment': '',
    'Stay Healthy At Work': '',
    'Questionnaire Reports': '',
    'Questionnaires': '',
    'Questionnaire': '',
    'Completions': '',
    'See More Stats': '',
    'Sessions': '',
    'hits': '',
    'Date/Time': '',
    'Traffic Reports': '',
    'Visitors Overview': '',
    'Time': '',
    '@shawLabel Statistics': '@shawLabel Statistics',
    'Questionnaire statistics': '',
    'shaw-starts': 'Questionnaire|Starts',
    'shaw-completes': 'Questionnaire|Completions',
    'shaw-completes-by-cond': 'Completions|By condition',
    'shaw-responses': 'Eligible|Responses',
    'shaw-responses-tooltip': 'An eligible response is a completed questionnaire that met the eligibility criteria for the health coaching program.',
    'shaw-callbacks': 'Callback|Requests',
    'shaw-callbacks-by-cond': 'Callback requests|By condition',
    'shaw-callbacks-tooltip': 'A callback request is an eligible respondent who requested a callback from a health coach.',
    'Redirecting': '',
    'Alerts': '',
    'Map': '',
    'Last Located': '',
    'Create a new group': '',
    'To create a group that has different French and English names, create the group first. You can then add a translation when you edit the group, after it has been created.': '',
    'Group Code': '',
    'Country': '',
    'Parent Group': '',
    'Products and Services': '',
    'None': '',
    'Once you\'ve chosen the parent group, you can specify what products and services the group can access.': '',
    'Active': '',
    'Create a new user': '',
    'First Name': '',
    'Last Name': '',
    'Email Address': '',
    'Confirm Email Address': '',
    'Password': '',
    'Confirm Password': '',
    'Mobile Phone Number': '',
    'User Group': '',
    'Dashboard Permissions': '',
    'None - Portal access only': '',
    'Dashboard Permissions allow you to specify which features a user can access. Administrator has all permissions.': '',
    'No French name provided': '',
    'Add a French name': '',
    'You can specify which products and services are available to the users in this group.': '',
    'Created': '',
    'Last Updated': '',
    'Page Name': '',
    'A page view is a view or hit of any page on your Platform. If a visitor reloads a web page, it will be counted as an additional page view.': '',
    'A unique visitor is an individual person. We use browser data, IP addresses, and other means to accurately identify unique visitors.': '',
    'An active user is someone who is able to login.': '',
    'Every user belongs to a group. A group is a way to organize your users if you need to break them up.': '',
    'Code': '',
    'Users in a deactivated group can no longer login.': '',
    'Every user group is associated with a Parent Group. All groups are related to each other and function similarly to a family tree.': '',
    'All': '',
    'Group Name': '',
    'Country Name or Code': '',
    'English': '',
    'French': '',
    'en': 'EN',
    'fr': 'FR',
    'Incorrect email or password. Please try again.': '',
    'Please enter valid information and try again.': '',
    'Success': '',
    'New user created.': '',
    'New group created.': '',
    'Changes saved.': '',
    'Oops!': '',
    'shaw-high-cholesterol': 'High Cholesterol',
    'shaw-depression': 'Depression',
    'shaw-high-blood-pressure': 'High Blood Pressure',
    'shaw-back-neck-pain': 'Back & Neck Pain',
    'shaw-stress-anxiety': 'Stress & Anxiety',
    'shaw-prediabetes': 'Pre-Diabetes',
    'shaw-muscle-joint': 'Muscle & Joint Conditions',
    'shaw-type2-diabetes': 'Type 2 Diabetes',
    'mhshaw-depression': 'MHC - Depression',
    'mhshaw-stress-anxiety': 'MHC - Stress and Anxiety',
  },
  'options': {
    'plural_rule': 'n > 1',
    'plural_number': '2',
  },
  'fr': {
    'You can look for a group and filter your search results, it works the same as the Users page.': 'Vous pouvez chercher un groupe et filtrer les résultats obtenus; le fonctionnement est le même que sur la page Utilisateurs.',
    'Now let’s take a look at user accounts! We’ve entered your name in the search bar to show you how it works.': 'Jetons un coup d’œil aux comptes d’utilisateurs! Pour vous montrer comment cela fonctionne, nous avons entré votre nom dans la barre de recherche.',
    'For faster results, you can use filters to locate a user account.': 'Vous pouvez appliquer des filtres afin de trouver un compte d’utilisateur plus rapidement.',
    'You can view and edit the user\'s account here.': 'Vous pouvez visionner et modifier le compte d’utilisateur ici.',
    'Next': 'Suivant',
    'Previous': 'Précédent',
    'Skip': 'Passer',
    'Done': 'Terminer',
    'Continue': 'Continuer',
    'Thanks for taking the tour! If you need a refresher, you can always access it from the menu.': 'Merci d’avoir fait cette visite! Pour vous rafraîchir la mémoire, vous pouvez la refaire en tout temps à partir du menu.',
    'Let\'s start with the basics - you can change the dashboard\'s language by clicking on your profile.': 'Commençons par l’essentiel : pour changer la langue du tableau de bord, cliquez sur votre profil.',
    'With this navigation menu, you can access the dashboard features available to you.': 'Grâce à ce menu, vous pouvez accéder aux éléments du tableau de bord qui vous sont destinés.',
    'Want to see how much traffic you got over the last few weeks? Use the date filter to select the last 30 days.': 'Curieux de connaître le nombre de visites sur votre site dans les dernières semaines? Utilisez le filtre des dates et sélectionnez les 30 derniers jours.',
    'Wonderful! You can hover over the graph to see more information. If you see "No Data" don\'t worry - check back soon to view the user activity on the Platform.': 'Fantastique! Déplacez le curseur au-dessus du graphique pour voir plus de données. Si la mention “aucune donnée” apparaît, ne vous inquiétez pas : revenez plus tard afin d’examiner l’activité des utilisateurs de la plateforme.',
    'Seeing the most popular pages is easy! You can view which topics, articles, tools, and services your members are engaging with most.': 'Il est facile de savoir quelles pages sont les plus populaires! Voyez ici les sujets, articles, outils et services que vos membres préfèrent.',
    'Novus Health Dashboard': 'Tableau de bord Novus Santé',
    'All Groups': 'Tous les groupes',
    'SMS': 'Message',
    'Email': 'Courriel',
    'Push Notification': 'Notification push',
    'Send As': 'Envoyer en tant que',
    'Today': 'Aujourd’hui',
    'Yesterday': 'Hier',
    'Last 7 Days': '7 derniers jours',
    'Last 30 Days': '30 derniers jours',
    'Select': 'Sélectionner',
    'Privacy': 'Politique de confidentialité',
    'Legal': 'Avis juridique',
    'Copyright': '\u200B',
    'Health Care Services International Inc.': 'Health Care Services International Inc.',
    'o/a Novus Health': 'exploitée sous le nom de Novus Santé',
    'You have encountered an error and the requested page cannot be displayed. Please try again.': 'Une erreur s’est produite et la page demandée ne peut pas s’afficher. Veuillez essayer de nouveau.',
    'Loading...': 'Chargement…',
    'Hi,': 'Bonjour,',
    'Logout': 'Déconnexion',
    'No Data': 'Aucune donnée',
    'Got it': 'D’accord',
    'Are you sure you want to leave this page?': 'Êtes-vous sûr de vouloir quitter cette page?',
    'Search': 'Rechercher',
    'No options': 'Aucune option',
    'Take a Tour': 'Découvrir le tableau de bord',
    'Access Denied': 'Accès refusé',
    'You do not have permission to access this page. For more information, please contact your Site Administrator.': 'Vous n’avez pas l’autorisation d’accéder à cette page. Pour en savoir plus, veuillez communiquer avec votre administrateur de site.',
    'Go back': 'Précédent',
    'Groups': 'Groupes',
    'Create': 'Créer',
    'Unsaved changes will be lost.': 'Les modifications non sauvegardées seront perdues.',
    'Confirm': 'Confirmer',
    'Cancel': 'Annuler',
    'Are you sure you want to switch languages?': 'Êtes-vous certain de vouloir changer de langue?',
    'Deactivate this group': 'Désactiver ce groupe',
    'Deactivate': 'Désactiver',
    'Are you sure you want to deactivate this group?': 'Êtes-vous certain de vouloir désactiver ce groupe?',
    'This will also deactivate any sub-groups related to this group.': 'Cela désactivera aussi tous les sous-groupes qui y sont liés.',
    'Products and Services will be unavailable': 'Produits et services inaccessibles',
    'Are you sure you want to change the Parent Group to {parentGroup_Name}?': 'Êtes-vous certain de vouloir changer le groupe principal pour {parentGroup_Name}?',
    'The following Products and Services will be unavailable:': 'Les produits et services suivants ne seront plus accessibles :',
    'Back to View': 'Revenir au mode affichage',
    'Edit': 'Modifier',
    'Save': 'Sauvegarder',
    'Unsaved changes will be lost': 'Les modifications non sauvegardées seront perdues',
    'Are you sure you want to proceed?': 'Êtes-vous certain de vouloir continuer?',
    'Permission(s) will be removed': 'L’autorisation sera supprimée',
    '{n} Permission(s) will be removed': 'Les autorisations seront supprimées',
    'Are you sure you want to change the user\'s group to {newGroupName}? The following permission(s) will be removed from the user\'s account:': 'Êtes-vous certain de vouloir changer le groupe de l’utilisateur pour {newGroupName}? L’autorisation suivante sera supprimée du compte de l’utilisateur :',
    '{n} Are you sure you want to change the user\'s group to {newGroupName}? The following permission(s) will be removed from the user\'s account:': 'Êtes-vous certain de vouloir changer le groupe de l’utilisateur pour {newGroupName}? Les autorisations suivantes seront supprimées du compte de l’utilisateur :',
    'Users': 'Utilisateurs',
    'Member Activity - Data Reports': 'Activités des membres - Rapports de données',
    'Access monthly reports to better understand how your members are taking advantage of the Novus Health health information specialist service. Reports will appear on this page within the first two weeks of the following month. Only specified administrators have access to this data.': 'Accédez aux rapports mensuels pour mieux comprendre comment vos membres profitent du service spécialisé en information sur la santé de Novus Sante. Les rapports apparaîtront sur cette page dans les deux premières semaines du mois suivant. Seuls les administrateurs spécifiés ont accès à ces données.',
    'Oops! Something went wrong, please try again and contact us if the issue continues.': 'Oops! Quelque chose s’est produit. Veuillez réessayer et contactez-nous si le problème persiste.',
    'Add a User': 'Ajouter un nouvel utilisateur',
    'Compose Message': 'Écrire un message',
    'Back': 'Retour',
    'Add a subject (Email Only)': 'Ajouter un nouvel objet (courriel uniquement)',
    'Send': 'Envoyer',
    'New': 'Nouveau',
    'Sent': 'Envoyé',
    'Received': 'Reçu',
    'User': 'Utilisateur',
    'Activity': 'Activité',
    'Messages': 'Messages',
    'New Message': 'Nouveau message',
    'How\'re we doing?': 'Qu’en pensez-vous?',
    'The Novus Dashboard is in beta, and we would love to get your feedback on how we’re doing. Looks, functionality, ease of use, whatever! Anything goes.': 'Ce tableau de bord Novus est en version bêta, et nous aimerions savoir comment vous l’évaluez. Son look, ses fonctionnalités, la facilité d’utilisation, tout ce que vous voulez! Tout sera utile.',
    'Name': 'Nom',
    'Topic': 'Sujet',
    'Feedback': 'Commentaires d’utilisateurs',
    'Feedback...': 'Rétroaction...',
    'Submit': 'Soumettre',
    'Bug Report': 'Rapport sur les bogues',
    'Design': 'Conception',
    'Content': 'Contenu',
    'Other': 'Autre',
    'Help': 'Aide',
    'Reset Your Password': 'Réinitialiser le mot de passe',
    'We need some information before we begin.': 'Nous avons besoin de quelques informations avant de commencer.',
    'All Done!': 'Terminé!',
    'Log In': 'Connexion',
    'Welcome to your dashboard': 'Bienvenue dans votre tableau de bord',
    'This is just the start.': 'Ce n’est que le début.',
    'Your dashboard begins with what matters to you the most. The Platform Usage page enables you to gain the data you need to help you build your business intelligence:': 'Votre tableau de bord affiche en premier ce qui vous importe le plus. La page sur l’utilisation de la plateforme vous permet d’obtenir les données qui vous aideront dans votre processus décisionnel :',
    'Understand usage trends over time': 'Déterminez graduellement les tendances d’utilisation',
    'Know how your members are engaging with the platform': 'Sachez de quelle façon vos membres interagissent avec la plateforme',
    'Gain insight into what topics your members are exploring': 'Découvrez quels sujets suscitent l’intérêt de vos membres',
    'Focus your search with these useful features:': 'Précisez votre recherche en vous servant de ces fonctions pratiques :',
    'Set your date range': 'Choisir une période donnée',
    'View group level data': 'Voir des données par groupe',
    'Review sessions or page views': 'Analyser les sessions ou les pages vues',
    'Analyze browser and OS usage percentages': 'Analyser les pourcentages d’utilisation selon le navigateur et le système d’exploitation',
    'View the most popular pages in each language': 'Voir les pages les plus consultées dans chaque langue',
    'Check back often as we release new updates, features, and controls that help you manage the experience of your clients and members!': 'Revenez souvent pour bénéficier de nouvelles mises à jour, fonctions et options de contrôle qui vous permettront de mieux gérer l’expérience vécue par vos clients et vos membres !',
    'Password Reset': 'Réinitialiser le mot de passe',
    'Log Into Your Novus Health Dashboard': 'Entrez dans votre tableau de bord de Novus Santé',
    'Login': 'Connexion',
    'Forgot Password': 'Vous avez oublié votre mot de passe',
    'Welcome to the Novus Health Dashboard!': 'Bienvenue dans le tableau de bord de Novus Santé!',
    'Looks like this is not the page you were looking for. To access your organization’s custom site, please enter the URL provided into the address bar at the top of the browser.': 'Il semble que ce ne soit pas la page que vous cherchiez. Pour accéder au site personnalisé de votre organisation, veuillez saisir l’adresse URL complète qui vous a été fournie dans la barre d’adresse en haut de la page de votre navigateur.',
    'Still can’t find what you’re looking for? Please contact your admin for information on how to access your custom dashboard.': 'Vous ne trouvez toujours pas ce que vous cherchez? Communiquez avec votre administrateur pour savoir comment accéder à votre tableau de bord personnalisé.',
    'Welcome aboard!': 'Bienvenue à bord!',
    'Start tour': 'Découvrir',
    'Maybe later': 'Plus tard',
    'Discover trends.': 'Découvrez les tendances.',
    'Gain insights.': 'Obtenez des données.',
    'Make decisions.': 'Prenez des décisions.',
    'Would you like to take the tour?': 'Voulez-vous découvrir le tableau de bord?',
    'Export': 'Exporter',
    'Platform Usage': 'Utilisation de la plateforme',
    'Select Language': 'Choisir la langue',
    'Show': 'Voir',
    'Select Limit': 'Sélectionner une limite',
    'per page': 'par page',
    'Page Title': 'Titre de la page',
    'Page Views': 'Nombre de pages vues',
    'Unique Visitors': 'Visiteurs uniques',
    'Total': 'Total',
    'var%': ' %',
    'Operating System': 'Système d\'exploitation',
    'Unique Visitors Percentage': 'Pourcentage de visiteurs uniques',
    'Browser': 'Navigateur',
    'Browsers': 'Navigateurs',
    'Filter by date': 'Filtrer par date',
    'Filter by group': 'Filtrer par groupe',
    'Starts': 'Commencés',
    'Ends': 'Processus complétés',
    'Health Risk Assessment': 'Évaluation des risques pour la santé',
    'Stay Healthy At Work': 'Présent et en santé',
    'Questionnaire Reports': 'Rapports sur les questionnaires',
    'Questionnaires': 'Questionnaires',
    'Questionnaire': 'Questionnaires',
    'Completions': 'Terminés',
    'See More Stats': 'Voir plus de statistiques',
    'Sessions': 'Sessions',
    'hits': 'visites',
    'Date/Time': 'Date / Heure',
    'Traffic Reports': 'Rapports sur le trafic',
    'Visitors Overview': 'Aperçu des visiteurs',
    'Time': 'Temps',
    '@shawLabel Statistics': 'Statistiques de @shawLabel',
    'Questionnaire statistics': 'Statistiques sur les questionnaires',
    'shaw-starts': 'Questionnaires|Commencés',
    'shaw-completes': 'Questionnaires|Terminés',
    'shaw-completes-by-cond': 'Résultats|Par problème de santé',
    'shaw-responses': 'Questionnaires|Admissibles',
    'shaw-responses-tooltip': 'Questionnaires remplis qui répondent aux critères d’admissibilité au programme d’accompagnement et coaching santé.',
    'shaw-callbacks': 'Demandes de|Rappel',
    'shaw-callbacks-by-cond': 'Demandes de rappel|Par problème de santé',
    'shaw-callbacks-tooltip': 'Répondants admissibles ayant demandé à être rappelés par un coach santé.',
    'Redirecting': 'Redirection',
    'Alerts': 'Alertes',
    'Map': 'Carte',
    'Last Located': 'Dernière position',
    'Create a new group': 'Créer un nouveau groupe',
    'To create a group that has different French and English names, create the group first. You can then add a translation when you edit the group, after it has been created.': 'Afin de créer un groupe portant un nom différent en anglais et en français, veuillez créer le groupe en premier. Après sa création, vous pouvez ajouter une traduction <strong>en modifiant</strong> le groupe.',
    'Group Code': 'Code de groupe',
    'Country': 'Pays',
    'Parent Group': 'Groupe principal',
    'Products and Services': 'Produits et services',
    'None': 'Aucun',
    'Once you\'ve chosen the parent group, you can specify what products and services the group can access.': 'Une fois que vous avez choisi le groupe principal, vous pouvez spécifier les produits et services auxquels le groupe peut accéder.',
    'Active': 'Actif',
    'Create a new user': 'Créer un nouvel utilisateur',
    'First Name': 'Prénom',
    'Last Name': 'Nom de famille',
    'Email Address': 'Adresse courriel',
    'Confirm Email Address': 'Confirmez votre adresse courriel',
    'Password': 'Mot de passe',
    'Confirm Password': 'Confirmez le mot de passe',
    'Mobile Phone Number': 'Numéro de téléphone portable',
    'User Group': 'Groupe d’utilisateurs',
    'Dashboard Permissions': 'Permissions d’accès au tableau de bord',
    'None - Portal access only': 'Aucune – accès au portail uniquement',
    'Dashboard Permissions allow you to specify which features a user can access. Administrator has all permissions.': 'Les permissions d’accès au tableau de bord vous permettent de spécifier les fonctionnalités auxquelles un utilisateur peut accéder. L’administrateur a toutes les permissions. ',
    'No French name provided': 'Aucun nom en français n’a été fourni',
    'Add a French name': 'Ajouter un nom en français',
    'You can specify which products and services are available to the users in this group.': 'Vous pouvez spécifier quels produits et services sont disponibles pour les utilisateurs de ce groupe.',
    'Created': 'Créé le',
    'Last Updated': 'Dernière mise à jour',
    'Page Name': 'Nom de la page',
    'A page view is a view or hit of any page on your Platform. If a visitor reloads a web page, it will be counted as an additional page view.': 'Une page vue est une vue ou un appel de fichier d’une page sur votre plateforme. Si un visiteur rafraîchit une page Web, celle-ci sera considérée comme une autre page vue.',
    'A unique visitor is an individual person. We use browser data, IP addresses, and other means to accurately identify unique visitors.': 'Un visiteur unique est un individu. Nous utilisons les données du navigateur, les adresses IP et d’autres moyens afin d’identifier avec exactitude les visiteurs uniques.',
    'An active user is someone who is able to login.': 'Un utilisateur actif est une personne capable d’ouvrir une session. ',
    'Every user belongs to a group. A group is a way to organize your users if you need to break them up.': 'Chaque utilisateur appartient à un groupe. Un groupe est un moyen d’organiser vos utilisateurs si vous avez besoin de les rassembler.',
    'Code': 'Code',
    'Users in a deactivated group can no longer login.': 'Les utilisateurs d’un groupe désactivé ne peuvent plus ouvrir de session.',
    'Every user group is associated with a Parent Group. All groups are related to each other and function similarly to a family tree.': 'Chaque groupe d’utilisateurs est associé à un groupe principal. Tous les groupes sont liés les uns aux autres et fonctionnent de manière semblable à un arbre généalogique.',
    'All': 'Tout',
    'Group Name': 'Nom de groupe',
    'Country Name or Code': 'Code ou nom de pays',
    'English': 'Anglais',
    'French': 'Français',
    'en': 'An.',
    'fr': 'Fr.',
    'Incorrect email or password. Please try again.': 'Courriel ou mot de passe incorrect. Veuillez réessayer.',
    'Please enter valid information and try again.': 'Veuillez entrer des informations valides, puis réessayez.',
    'Success': 'Succès',
    'New user created.': 'Nouvel utilisateur créé.',
    'New group created.': 'Nouveau groupe créé.',
    'Changes saved.': 'Changements enregistrés.',
    'Oops!': 'Oops!',
    'shaw-high-cholesterol': 'Hypercholestérolémie',
    'shaw-depression': 'Dépression ',
    'shaw-high-blood-pressure': 'Hypertension',
    'shaw-back-neck-pain': 'Maux de dos et de cou',
    'shaw-stress-anxiety': 'Stress et anxiété',
    'shaw-prediabetes': 'Prédiabète',
    'shaw-muscle-joint': 'Affections musculaires et articulaires',
    'shaw-type2-diabetes': 'Diabète de type 2',
    'mhshaw-depression': 'CSM - Dépression',
    'mhshaw-stress-anxiety': 'CSM - Stress et anxiété',
  },
}



// WEBPACK FOOTER //
// ./src/language/translations.js